'use client';
import { useState } from 'react';
import { useHover } from './useHover';
export const useIsHovered = (ref) => {
    const [isHovered, setIsHovered] = useState(undefined);
    useHover(ref, (props) => setIsHovered(props.isHovered));
    return isHovered;
};
